<template>
  <div :class="{ 'invalid': !isValid, 'valid': isValid}">
    <label :for="name">{{label}}</label>
    <div v-if="!isValid" class="error">{{ errorDescription }}</div>
    <div class="group-refresh">
      <input
        :id="name" 
        autocomplete="off"
        :name="name" 
        :disabled="isDisabled" 
        :placeholder="placeholder" 
        :value="currentSecured"
        :type="isHidden ? 'password' : 'text'"
        @input="updateValue($event.target.value)"
      />
      <a @click="generate">
        <BaseIcon name="sync-alt" class="icon red" size="xs" />
      </a>
    </div>
    
  </div>
</template>

<script>
  import BaseIcon from "@/components/base/Icon";

	export default {
    components: {
      BaseIcon
    },
    computed : {},
    props: {
      label: String,
      name: String,
      value: String,
      isTextArea: Boolean,
      isDisabled: Boolean,
      isHidden: Boolean,
      placeholder: String,
      totalChar: Number,
      isNumberOnly: Boolean,
      minChar: Number,
      maxChar: Number,
      value: String,
      validation: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        currentSecured: "",
        isValid: Boolean,
        errorDescription: (this.name.charAt(0).toUpperCase() + this.name.substring(1))+ ' is not valid'
      }
    },
    mounted() {
      this.currentSecured = this.value
    },
    methods:{
      updateValue(typed) {
        this.currentValue = typed
        this.$emit('input', typed)
      },
      generate() {
        if (this.isNumberOnly) {
          this.generatePincode()
        } else {
          this.generatePassword()
        }
      },
      generatePassword() {
        var length = this.totalChar,
        charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()+`|}{[]:;?><=',
        retVal = '';
        for (var i = 0, n = charset.length; i < length; ++i) {
          retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        this.currentSecured = retVal;
        this.$emit('input', this.currentSecured)
      },
      generatePincode() {
        var length = this.totalChar,
        charset = '0123456789',
        retVal = '';
        for (var i = 0, n = charset.length; i < length; ++i) {
          retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        this.currentSecured = retVal;
        this.$emit('input', this.currentSecured)
      }
    },
    watch: {
      validation: function(newVal, oldVal) {
        this.isValid = newVal

        // if(this.minChar <= this.currentSecured && this.maxChar >= this.currentSecured) {
        //   this.isValid = newVal
        //   this.errorDescription = this.label + ' is not valid'
        // } else {
        //   this.isValid = newVal
        //   this.errorDescription = this.label + " isn't the correct length"
        // }
      },
    }
	}
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";

input {
  width: 100%;
  color: #707070;
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #EFEFEF;
  outline: none;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  font-weight: 500;
  background-color: #FFFFFF;
  resize: none;

  &:focus {
    color: #707070;
    border: 1px solid #707070;
  }
  &:disabled {
    background-color: #F8F8F8;
    border: 1px solid #EEEEEE;
    color: #C6C6C6;
  }
}
.group-refresh{
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  input {
    width: 92%;
  }

  a {  
    display: flex;
    justify-content: center;
    align-items: center;
    width: 4%;
    height: 29px !important;
    padding: 0;
  }
}

.error {
  color: $error-color;
  position: absolute;
  top: -20px;
  right: 8%;
  font-size: 13px;
  font-weight: 500;
}
.valid,
.invalid {
  &::after {
    position: absolute;
    top: 50%;
    right: -20px;
  }
}
.invalid {
  input,
  textarea {
    border: 1px solid $error-color;
  }
}
</style>
